// @flow

import type { Profile } from 'Common/profiles/types';

export class Role {
  displayName: string;

  // whether this role matches a role id received from the server
  matchesId: (id: string) => boolean;

  // return a role id to send to the server
  getId: (oldId: ?string) => string;

  constructor(
    displayName: string,
    matchesId: (id: string) => boolean,
    getId: (oldId: ?string) => string,
  ) {
    this.displayName = displayName;
    this.matchesId = matchesId;
    this.getId = getId;
  }

  toString() {
    return this.displayName;
  }
}

const equalIgnoreCase = (value: ?string, valueToCompareWith: string): boolean =>
  value != null && value.toLowerCase() === valueToCompareWith.toLowerCase();

export const ROLE_ADMIN: Role = new Role(
  'Admin',
  (id: string) => equalIgnoreCase(id, 'admin') || equalIgnoreCase(id, 'master'),
  (oldId: ?string) => (oldId && equalIgnoreCase(oldId, 'master') ? oldId : 'admin'),
);

export const ROLE_VIEWER: Role = new Role(
  'Viewer',
  (id: string) => equalIgnoreCase(id, 'viewer'),
  () => 'viewer',
);

export const ROLE_KID: Role = new Role(
  'Kid',
  (id: string) => equalIgnoreCase(id, 'kid') || equalIgnoreCase(id, 'kids'),
  () => 'kids',
);

export const isAdminOrMaster = (uuid: ?string, profile: Profile): boolean =>
  profile.id === uuid || profile.id === 'master' || profile.isMaster;

export const ROLES: Array<Role> = [ROLE_ADMIN, ROLE_VIEWER, ROLE_KID];
export const DEFAULT_ROLE = ROLE_VIEWER;

export const bindToRoleById = (roleId: string) =>
  ROLES.find(role => role.matchesId(roleId)) || DEFAULT_ROLE;

// Prepare roles list for rendering in Dropdown web component
export const prepareRolesForRenderInDropdown = (ROLES: Array<Role>) =>
  ROLES.reduce((role, item) => {
    role[item.getId()] = item.displayName;
    return role;
  }, {});
